import axios from 'axios';

const state = {
  hasUser: false,
  userId: -1,
  created: '0001-01-01T00:00:00',
  email: '',
  firstName: '',
  fullName: '',
  isNewUser: false,
  lastLogin: '0001-01-01T00:00:00',
  lastName: '',
  role: -1,
  sessionId: '',
  subscriptionExpires: '0001-01-01T00:00:00',
};

const mutations = {
  clearUser(state) {
    state.userId = -1;
    state.created = '0001-01-01T00:00:00';
    state.email = '';
    state.firstName = '';
    state.fullName = '';
    state.isNewUser = false;
    state.lastLogin = '0001-01-01T00:00:00';
    state.lastName = '';
    state.role = -1;
    state.sessionId = '';
    state.subscriptionExpires = '0001-01-01T00:00:00';
    state.hasUser = false;
  },
  setUser(state, user) {
    state.userId = user.userId;
    state.created = user.created;
    state.email = user.email;
    state.firstName = user.firstName;
    state.fullName = user.fullName;
    state.isNewUser = user.isNewUser;
    state.lastLogin = user.lastLogin;
    state.lastName = user.lastName;
    state.role = user.role;
    state.sessionId = user.sessionId;
    state.subscriptionExpires = user.subscriptionExpires;
    state.hasUser = true;
  },
};

const actions = {
  fetchUserAsync(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${context.rootState.apiHost}/user`,
          {
            headers: { Authorization: `Bearer ${context.rootState.bearerToken}` }
          }
        )
        .then((result) => {
          if (result.data) {
            context.commit('setUser', result.data);
            resolve();
          } else {
            reject();
          }
        })
        .catch(() => {
          // TODO: error handling
          reject();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
